import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');

    if (!token) {
        // Redireciona para login se o token não existir
        return <Navigate to="/" />;
    }

    return children;
};

export default ProtectedRoute;
